<template>
  <div class="page">
    <van-popup v-model="show" round :style="{width:'80%'}" :close-on-click-overlay="false"  get-container="body">
       <!-- :get-container="isPhoneIOS ? 'body' : '#app'" -->
      <div class="box">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          ref="form"
        >
          <van-field
            required
            v-model="spikeGoodsItem.goodName"
            label-align="left" 
            input-align="right" 
            label="名称"
            :maxlength="16"
            placeholder="请输入商品名称"
            :show-error-message="false" 
            :rules="[{ required: true, message: '请输入商品名称' }]"
          />
          <van-field
            required
            v-model="spikeGoodsItem.oldPrice"
            label-align="left" 
            input-align="right" 
            label="原价"
            type="number"
            placeholder="请输入原价"
            :show-error-message="false" 
            :rules="[{ required: true, message: '请输入原价' }]"
            @blur="checkFeeValid('oldPrice')"
          />
          <van-field
            required
            :disabled="spikeGoodsItem.isActiveStart"
            v-model="spikeGoodsItem.spikePrice"
            label-align="left" 
            input-align="right" 
            label="秒杀价"
            type="number"
            placeholder="请输入秒杀价"
            :show-error-message="false" 
            :rules="[{ required: true, message: '请输入秒杀价' }]"
            @blur="checkFeeValid('spikePrice')"
          />
          <van-field
            v-if="boolPrePay"
            required
            :disabled="spikeGoodsItem.isActiveStart"
            v-model="spikeGoodsItem.preSpikePrice"
            label-align="left" 
            input-align="right" 
            label="秒杀定金"
            type="number"
            placeholder="请输入秒杀价"
            :show-error-message="false" 
            :rules="[{ required: true, message: '请输入秒杀定金' }]"
            @blur="checkFeeValid('preSpikePrice')"
          />
          <van-field
            v-model="spikeGoodsItem.goodsTag"
            label-align="left" 
            input-align="right" 
            label="标签"
            maxlength="6"
            placeholder="请输入标签"
            :show-error-message="false"
            :disabled="spikeGoodsItem.isActiveStart"
          />
          <van-field 
            required
            name="headImg"  
            label-align="left" 
            input-align="right"  
            label="商品头图"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="spikeGoodsItem.headImgList" 
                :after-read=" (e) => uploadImg(e,'headImgList')"
                @delete="(file) => deleteImg(file,'headImgList')"
              />
            </template>
          </van-field>
          <van-field
            required
            v-model="spikeGoodsItem.goodsNumber"
            label-align="left" 
            input-align="right" 
            label="库存"
            maxlength="7"
            type="digit"
            placeholder="请输入库存"
            :formatter="formatter"
            :show-error-message="false" 
            :rules="[{ required: true, message: '请输入库存'}]"
            @blur="checkFeeValid('goodsNumber')"
          />
          
          <span class="tips" v-if="from == 'manager' && !spikeGoodsItem.isNewAddSections && spikeGoodsItem.goodsId">库存不能小于真实销售量：当前销售量为{{volume}}</span>
          <span class="tips" v-else>库存不能小于实际销售量</span>
          <van-field
            v-model="spikeGoodsItem.virtualNumber"
            type="digit"
            maxlength="7"
            label-align="left" 
            input-align="right" 
            label="虚拟库存"
            placeholder="请输入虚拟库存"
            :show-error-message="false" 
            @blur="checkFeeValid('virtualNumber')"
          />
        </van-form>
        <div class="img-box">
          <div class="img-title">商品详情</div>
            <van-uploader 
              class="uploader" 
              :fileList="spikeGoodsItem.detailsImg" 
              :max-count="5" 
              result-type="file"
              :before-read="beforeImgUpload" 
              :after-read=" (e) => uploadImg(e,'detailsImg')"
              @delete="(file) => deleteImg(file,'detailsImg')"
            />
        </div>
        <div class="footer" v-show="bottomIsShow">
          <div class="button cancel" @click="onCancel">取消</div>
          <div class="button" @click="onFailed">
            {{from == 'manager' && !spikeGoodsItem.isNewAddSections ? '保存并上架' : '保存'}}
          </div>
        </div>
        <div style="height:46px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { round2Places } from "@/utils/utils";
export default {
  props: {
    isAddGoods:{
      type: Boolean,
      default: false
    },
    spikeGoodsItem: {
      type: Object,
      default() {
        return {}
      }
    },
    defaultPhoneHeight: {
      type: Number,
    }
  },
  computed: {
    show: {
      get() {
        return this.isAddGoods
      },
      set(newVal) {
        this.$emit('update:isAddGoods', newVal)
      }
    },
    from() {
      return this.$route.query.from
    },
    activityId() {
      return  this.$route.query.activityId || ''
    },
    isClone() {
      return this.$route.query.from == 'clone';
    },
    boolPrePay() {
      return JSON.parse(this.spikeGoodsItem.boolPrePay || false)
    }
  },
  watch:{
    nowPhoneHeight:function(){
      if(this.defaultPhoneHeight != this.nowPhoneHeight){
        // 当软键盘弹出,改变bottomIsSHow变量然后去控制bottom的显示与隐藏
        this.bottomIsShow=false;
      }else{
        // 相等代表软键盘收起后,与上同理
        this.bottomIsShow=true
      }
    },
  },
  data() {
    return {
      isUploadImg: false,
      bottomIsShow:true,//控制底部tabbar显示与隐藏
      nowPhoneHeight:0, //屏幕现在的高度,
      volume: 0,
    }
  },
  methods:{
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(file,type) {
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.spikeGoodsItem[type].push(currentFile)
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            currentFile.status = 'done'
            delete this.spikeGoodsItem[type][0].status
            delete this.spikeGoodsItem[type][0].message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.isUploadImg = false
          const currentIndex = this.spikeGoodsItem[type].indexOf(currentFile);
          if (currentIndex > -1) {
            this.spikeGoodsItem[type].splice(currentIndex, 1);
          }
      });
    },
    deleteImg(file,type) {
      const currentIndex = this.spikeGoodsItem[type].indexOf(file);
      if (currentIndex > -1) {
        this.spikeGoodsItem[type].splice(currentIndex, 1);
      }
    },
    onFailed() {
      // 图片上传中
      if (this.isUploadImg) return
      this.$refs.form.validate().then(res => {
        if (this.spikeGoodsItem.headImgList.length) {
          if (this.from == 'manager' || this.from == 'home') {
            if (this.from == 'manager') {
              if (this.spikeGoodsItem.goodsNumber < this.spikeGoodsItem.volume) {
                this.$toast(`库存小于实际已使用库存，请重新修改！ 当前已使用库存”${this.spikeGoodsItem.volume}“`)
                return
              }
              this.spikeGoodsItem.status = 0
            }
            const obj = this.initGoodsItem(this.spikeGoodsItem)
            this.$api.spike.saveGoods(obj).then(res => {
              if (res.success) {
                this.spikeGoodsItem.goodsId = res.data
                this.$emit('addGoodsSuccess', this.spikeGoodsItem)
                this.show = false
                this.$toast('保存成功')
              } 
            })
          }else {
            this.$emit('addGoodsSuccess', this.spikeGoodsItem)
            this.show = false
          }
        }else {
          this.$toast('请上传商品头图')
        }
      }).catch(err => {
        this.$toast(err[0].message);
      })
    },
    onCancel() {
      this.form = this.spikeGoods
      this.show = false
    },
    formatter(value) {
      if (value == 0 && value) {
        return 1
      }else {
        return value
      }
      
    },
    checkFeeValid(fieldName) {
      let parame = this.spikeGoodsItem[fieldName]
      if (fieldName == 'oldPrice' || fieldName == 'goodsNumber' || fieldName == 'virtualNumber') {
        if (parame > 1000000) {
          this.spikeGoodsItem[fieldName] = 1000000
          return
        } 
      }
      if (fieldName == 'spikePrice' || fieldName == 'preSpikePrice' ) { 
        this.spikeGoodsItem[fieldName] = round2Places(parame)
        if (parame && parame < 0.01 ) {
          this.spikeGoodsItem[fieldName] = 0.01
          // this.spikeGoodsItem[fieldName] = 0
        }else if(parame > 999999.99){
          this.spikeGoodsItem[fieldName] = 999999.99
        }
        return
      }
      // 已经开始的秒杀 库存只能增加
      if (fieldName == 'goodsNumber' && this.spikeGoodsItem.isActiveStart) {
        // console.log(this.spikeGoodsItem.isActiveStart,this.spikeGoodsItem.originalGoogsNumber)
        // if (parame < this.spikeGoodsItem.originalGoogsNumber) {
        //   this.spikeGoodsItem[fieldName] = this.spikeGoodsItem.originalGoogsNumber
        //   return
        // }
        this.spikeGoodsItem[fieldName] = round2Places(parame)
        if (parame < this.spikeGoodsItem.volume) {
          this.$toast(`库存小于实际已使用库存，请重新修改！ 当前已使用库存”${this.spikeGoodsItem.volume}“`)
          return
        }

      }
      this.spikeGoodsItem[fieldName] = round2Places(parame)
    },
    initGoodsItem(obj) {
      obj.headImg = obj.headImgList[0].url
      obj.addGoodsNumber =  this.spikeGoodsItem.goodsNumber - this.spikeGoodsItem.originalGoogsNumber
      obj.goodsDetails = []
      if (obj.detailsImg.length) {
          obj.detailsImg.forEach(item => {
          obj.goodsDetails.push(item.url)
        })
      }
      return obj
    },
  },
  mounted() {
    window.onresize = ()=>{ //这个方法会被调用两次,软键盘弹出后和软件收起后
      this.nowPhoneHeight = window.innerHeight 
    }
    if (this.from == 'manager' && this.spikeGoodsItem.goodsId) {
      this.$api.spike.goodsSoldNumber(this.spikeGoodsItem.goodsId).then(res => {
        if (res.success) {
          this.volume = res.data
        }
      })
    }
  },
  destroyed() {
    //页面销毁前要记得这个监听消除掉;
    window.onresize = null
  }
}
</script>

<style lang="stylus" scoped>
.box {
  padding-top: 10px;
  height: 520px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .tips {
    font-size: 10px;
    color: #bbb;
    padding-left: 16px;
  }
  .img-box {
    padding: 10px 16px;
    .img-title {
      margin-bottom: 6px;
    }
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    padding 0 10px
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
}
</style>
